//
// Mobile vertical scroll (replaces horizontal snap on small viewports)
// ================================================================================

import { ScrollTrigger } from './gsap-init.js';
import { isMobileVerticalScrollActive } from './scroll-mode.js';

const PARALLAX_SCRIPT_URL = 'https://adso-pictures.b-cdn.net/parallax.js';

function loadScript(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}

export function initMobileVerticalScroll() {
    if (!isMobileVerticalScrollActive()) return;

    const body = document.body;
    const html = document.documentElement;

    body.classList.add('vertical-scroll-mobile');

    // Un solo contenedor de scroll: html scrollea, body no
    html.style.overflowX = 'hidden';
    html.style.overflowY = 'auto';
    body.style.overflowX = 'hidden';
    body.style.overflowY = 'visible';

    const main = document.querySelector('.c-main.horizontal-scroll-wrapper');
    if (main) {
        main.style.opacity = '1';
        main.style.transform = 'none';
    }

    // Quitar scroll interno de secciones (sobre, reparto, entrevista): en móvil todo es scroll de página
    document.querySelectorAll('[data-has-internal-scroll]').forEach((section) => {
        section.removeAttribute('data-has-internal-scroll');
        section.style.removeProperty('height');
        section.style.removeProperty('max-height');
        section.style.removeProperty('overflow');
        section.style.removeProperty('overscroll-behavior');
    });

    document.querySelectorAll('.section-screen__content').forEach((content) => {
        content.style.removeProperty('overflow');
        content.style.removeProperty('max-height');
        content.style.removeProperty('min-height');
    });
}

function initLegacyParallaxInstances() {
    const $ = window.jQuery;
    if (!$ || !$.fn.parallax) return;

    $('.mobile-parallax-divider [data-parallax="scroll"]').each(function initDivider() {
        const $el = $(this);
        const existing = $el.data('px.parallax');
        if (existing && typeof existing.destroy === 'function') {
            existing.destroy();
        }
        $el.parallax({ speed: 0.4 });
    });
}

export function initLegacyMobileParallax() {
    if (!isMobileVerticalScrollActive()) return Promise.resolve();

    const run = () => {
        requestAnimationFrame(initLegacyParallaxInstances);
    };

    const $ = window.jQuery;
    if ($ && $.fn.parallax) {
        if (document.readyState === 'complete') {
            run();
        } else {
            window.addEventListener('load', run, { once: true });
        }
        return Promise.resolve();
    }

    return loadScript(PARALLAX_SCRIPT_URL)
        .then(() => {
            if (document.readyState === 'complete') {
                run();
            } else {
                window.addEventListener('load', run, { once: true });
            }
        })
        .catch((err) => console.warn('No se pudo cargar parallax.js legacy:', err));
}

export function finalizeMobileVerticalScroll() {
    if (!isMobileVerticalScrollActive()) return;

    if (ScrollTrigger?.normalizeScroll) {
        ScrollTrigger.normalizeScroll(true);
    }

    initLegacyMobileParallax().then(() => {
        requestAnimationFrame(() => {
            ScrollTrigger.refresh();
        });
    });
}
